import { render, staticRenderFns } from "./customExports.vue?vue&type=template&id=85a7431a&"
import script from "./customExports.vue?vue&type=script&lang=js&"
export * from "./customExports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports